import React, { PropTypes } from 'react';
import classnames from 'classnames';

export default class Plant extends React.Component {
  static propTypes = {
    src: PropTypes.string,
    title: PropTypes.string,
    city: PropTypes.string,
    division: PropTypes.string,
  }

  render() {
    const { src, title, city, division } = this.props;

    const styles = {
      wrapper: classnames('plant'),
      content: classnames('plant--content'),
      title: classnames('plant--title'),
      city: classnames('plant--city'),
      division: classnames('plant--division'),
      triangle: classnames('plant--triangle'),
      thumb: classnames('plant--thumb'),
    };

    const inlineStyles = {
      thumb: {
        backgroundImage: `url(${src})`,
      },
    };

    return (
      <div className={styles.wrapper}>
        <div className={styles.thumb} style={inlineStyles.thumb}></div>
        <div className={styles.content}>
          <div className={styles.title}>{title}</div>
          <div className={styles.city}>{city}</div>
          <div className={styles.division}>{division}</div>
          <svg className={styles.triangle} viewBox="0 0 180 140">
            <polygon points="0,0 180,0 0,140" />
          </svg>
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./web/js/components/Plant.jsx
 **/